import React, { useCallback } from 'react';
import { AppButton, Box } from '@common-fe/common-fe';

import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const MultipleRequestsFooterActions = () => {
  const { setIsDividingMode, setEditableLockbox } = useLockboxDetailsStore();

  const handleNotMultipleRequest = useCallback(() => {
    setEditableLockbox({ isMultipleRecordsWarning: false });
  }, [setEditableLockbox]);

  const handleSetDiviningMode = useCallback(() => {
    setIsDividingMode(true);
  }, [setIsDividingMode]);

  return (
    <>
      <Box margin={{ right: 'spacing12' }}>
        <AppButton
          testId="not-multiple-request"
          buttonType="secondary"
          onClick={handleNotMultipleRequest}
        >
          Not Multiple Request?
        </AppButton>
      </Box>

      <Box>
        <AppButton
          testId="dividing-mode"
          onClick={handleSetDiviningMode}
        >
          Dividing Mode
        </AppButton>
      </Box>
    </>
  );
};

export default MultipleRequestsFooterActions;
